import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navmenupersonal',
  templateUrl: './navmenupersonal.component.html',
  styleUrls: ['./navmenupersonal.component.css']
})
export class NavmenupersonalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
